import { I18n } from 'aws-amplify'

export const Strings = () => ({
  temperature: I18n.get('Temperature')
})